import _ from 'lodash'

/**
 * Functions for casing strings.
 */
export default {

    /**
     * Converts any string to camel case.
     *
     * @param {string} value
     * @returns The string camel cased.
     */
    camelCase(value) {

        let retVal = value.replace(/(?:^\w\|[A-Z]|\b\w|\s+)/g, function(match, index) {
            if (+match === 0) return '' // or if (/\s+/.test(match)) for white spaces
            return index == 0 ? match.toLowerCase() : match.toUpperCase()
        })

        // Handle edge case of acronyms such as ECP and SQL.
        if (retVal.length > 1 && retVal[0] == retVal[0].toLowerCase() && retVal[1] == retVal[1].toUpperCase())
            retVal = retVal[0].toUpperCase() + retVal.substring(1)

        return retVal
    },

    /**
     * Converts any string to kebab case.
     *
     * @param {string} value
     * @returns The string kebab cased.
     */
    kebabCase(value) {
        return (value.match(/[A-Z]{2,}(?=[A-Z][a-z]+[0-9]*|\b)|[A-Z]?[a-z]+[0-9]*|[A-Z]|[0-9]+/g) || [])
            .map(x => x.toLowerCase()).join('-')
    },

    /**
     * Converts any string to proper case.
     *
     * @param {string} value
     * @returns The string proper cased.
     */
    properCase(value) {
        return value.replace(/\w\S*/g, function(txt){
            return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase()
        })
    },

    /**
     * Converts any string to start case.
     *
     * @param {string} value
     * @returns The string start cased.
     */
    startCase(value) {

        // Handle edge cases for casing not to change.
        const exclusions = [
            { val: 'kWp', spaceAfter: true },
            { val: '.' },
        ]

        let elements = [ value ]

        const exclusionsKeyMap = exclusions.map(ex => {
            return { val: ex.val, display: (ex.spaceBefore ? ' ' : '') + ex.val + (ex.spaceAfter ? ' ' : '') }
        })

        exclusions.forEach(item => {
            for (let i = 0; i < elements.length; i++) {
                const el = elements[i]
                if (el.includes && el.includes(item.val)) {
                    const newParts = []
                    const parts = el.split(item.val)
                    for (let pi = 0; pi < parts.length; pi++) {
                        newParts.push(parts[pi])
                        if (pi + 1 < parts.length) {
                            const exclusionDisplay = exclusionsKeyMap.find(ex => ex.val == item.val).display
                            newParts.push(exclusionDisplay)
                        }
                    }
                    elements[i] = newParts
                } else {
                    elements[i] = [ el ]
                }
            }

            elements = _.flattenDeep(elements)
        })
        for (let i = 0; i < elements.length; i++) {
            elements[i] = exclusionsKeyMap.find(item => item.display === elements[i])
                ? elements[i] : _.startCase(elements[i])
        }

        return elements.join('')
    },

    /**
     * Converts any string to upper case.
     *
     * @param {string} value
     * @returns The string upper cased.
     */
    upperCase(value) {
        return value.toUpperCase()
    },

    /**
     * Converts any string to lower case.
     *
     * @param {string} value
     * @returns The string lower cased.
     */
    lowerCase(value) {
        return value.toLowerCase()
    },
}
